var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-wrapper-container"},[_c('div',{staticClass:"auth-card"},[_c('img',{staticClass:"logo",attrs:{"src":require("@assets/img/Default.png"),"alt":"Web Orion Logo"}}),_vm._t("default")],2),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('p',[_vm._v(" WebOrion is an innovative creation of Cloudsine Pte Ltd. "),_c('br'),_vm._v(" All Rights Reserved. ")])])
}]

export { render, staticRenderFns }